import React from 'react'
import { Spinner } from '../components/Spinner'
import { ProductPriceAvailable, ProductPriceUnavailable } from '../productPricing/ProductPricingContext'
import classNames from 'classnames'
import { PriceTypeLabel } from './PriceTypeLabel'

interface ListPriceProps {
  priceLoading?: boolean
  price: ProductPriceAvailable | typeof ProductPriceUnavailable
  priceDisclaimer?: string | null
  showPrice?: boolean
  total?: boolean
  priceTypeLabel?: PriceTypeLabel
  compact?: boolean
}

export const ListPrice: React.FC<ListPriceProps> = (props) => {
  const { priceLoading, price, priceDisclaimer, total, showPrice, priceTypeLabel, compact } = props

  // None of the PDL products have price data, for example.
  if (!showPrice) {
    return null
  }

  return (
    <div className={classNames('ListPrice', { compact })}>
      <>
        <div className={classNames('dollars', { loading: priceLoading })}>
          {/* always display loadedContent div so it can transition opacity in */}
          <div className="loadedContent">
            {(!priceLoading && price === ProductPriceUnavailable) && (!total ? 'Price Unavailable' : 'Pricing is unavailable for some products')}
            {(!priceLoading && price !== ProductPriceUnavailable) && (
              <>
                {priceTypeLabel && (<span className="priceLabel">{priceTypeLabel.label}</span>)}
                <span className="priceDollars">{total ? 'Total ' : ''} ${price.toFixed(2)}</span>
                <span className="gstTag">{priceTypeLabel?.longLabel}</span>
              </>
            )}
          </div>
          {
            priceLoading && (
              <div className="loadingContent">
                Checking price
                <Spinner size={compact ? 16 : 28} inline/>
              </div>
            )
          }
        </div>
        {
          priceDisclaimer && (
            <div className="bulkPackDisclaimer">
              {priceDisclaimer}
            </div>
          )
        }
      </>
    </div>
  )
}